var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "train" } }, [
    _c("div", { attrs: { id: "Return_Bar" } }, [
      _c("i", { staticClass: "el-icon-arrow-left" }),
      _vm._v(" "),
      _c("div", { staticClass: "isreturn", on: { click: _vm.isreturn } }, [
        _vm._v("返回")
      ])
    ]),
    _vm._v(" "),
    _c("div", { attrs: { id: "text" } }, [
      _c("div", { staticClass: "boxstyle" }),
      _vm._v(" "),
      _c("iframe", {
        staticClass: "frame",
        attrs: { src: _vm.urlLink, scrolling: "auto", frameborder: "0" }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-031f84a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-031f84a2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/train/webPageLink.vue
// module id = 1583
// module chunks = 0